/* AD-07 · EMAIL & TEMPLATE OPS
   ADM-15/17/34/35: queue/bounce/complaint thresholds, suppression propagation,
   notification lineage, template/version registry with legal/copy approval.
   · Bible §50 */
import { Button, ListRow, Tile, Tiles } from '@/ui'
import { useAdmin } from './AdminShell'

export default function AD07EmailOps() {
  const e = useAdmin().email
  return (
    <section data-frame="AD-07" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">Opérations e-mail &amp; modèles</h2>
      <Tiles>
        {e.tiles.map(t => <Tile key={t.label} label={t.label} value={t.value} hint={t.hint} />)}
      </Tiles>
      <div>
        {e.rows.map(r => (
          <ListRow key={r.title} title={r.title} meta={r.meta}
            end={<Button variant="ghost" size="sm">{r.action}</Button>} />
        ))}
      </div>
    </section>
  )
}
